const ShoppingCartIcon = ({ style, width = '24px', height = '24px', ...props }) => {
    return (
        <img
            src="/icons/shopping-cart.svg"
            alt="Shopping Cart"
            width={width}
            height={height}
            style={{ display: 'block', ...style }}
            {...props}
        />
    );
};

export default ShoppingCartIcon;
